module.exports = __webpack_public_path__ + "img/15.03bd6d29.png";